import { SystemStyleObject } from "@styled-system/css";
import React from "react";

import Container from "./Container";
import LegacyBox from "./LegacyBox";

type PageWidthSectionProps = {
  sx?: SystemStyleObject;
  fullBleed?: boolean;
  children: React.ReactNode;
};

function PageWidthSection(
  { sx, fullBleed, children }: PageWidthSectionProps,
  ref: React.Ref<unknown>
) {
  return (
    <LegacyBox sx={{ paddingY: "xlarge", ...sx }} ref={ref}>
      <Container fullBleed={fullBleed}>{children}</Container>
    </LegacyBox>
  );
}

export default React.forwardRef(PageWidthSection);
